'use strict';

function utilityWrapper(dateTimeUtility, uriUtility, utility) {

	return {
		dateTimeUtility: dateTimeUtility,
		uriUtility: uriUtility,
		utility: utility
	};
}

// export module
module.exports = utilityWrapper(require('./src/dateTimeUtility'), require('./src/uriUtility'), require('./src/utility'));
